<script lang="ts">
  export let name: string
  export let group: any
  export let value: any
  export let onChange: () => any | undefined = undefined
  export let disabled = false
</script>

<div class="py-2" class:opacity-50={disabled}>
  <label class="flex items-center">
    <input
      type="radio"
      id="{name}-{value}"
      data-role="{name}-{value}"
      {name}
      bind:group
      on:change={onChange}
      {value}
      {disabled}
      class="shrink-0 mr-1"
    />
    <slot />
  </label>
</div>
